// extracted by mini-css-extract-plugin
export default {"root":"ContactPage_root__-nrFt","mainContent":"ContactPage_mainContent__frNLy"};